import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/yngve-windsland-Y4X1vM4FVfA-unsplash.jpeg";

function EAAKonkurranseevne() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.eaaCompetitiveness.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.eaaCompetitiveness.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/eaa-konkurranseevne-bransjer"
        />
      </Helmet>

      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.eaaCompetitiveness.title")}
          </h1>
          <p className="text-xl mb-2">
          {i18next.t("pages.articles.list.eaaCompetitiveness.sections.intro.content")}
              <a
                href="/artikler/tilgjengelighetsdirektivet"
                className="underline hover:text-contrast-ink"
              >
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.intro.link")}
              </a>
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.intro.content2")}
          </p>
         
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.eaaCompetitiveness.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left">
          <img
            className="w-full h-full object-cover"
            src={article_img}
            alt={i18next.t("pages.articles.list.eaaCompetitiveness.imageAlt")}
          />
        </div>
      </div>

      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
          <p className="mb-2">
            {i18next.t("pages.articles.list.eaaCompetitiveness.sections.intro.content3")}
          </p>
            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.bankInsurance.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.bankInsurance.description")}
            </p>
            <ul className="list-disc ml-6 mb-8">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.bankInsurance.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.bankInsurance.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.bankInsurance.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.bankInsurance.opportunity")}
              </li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.telecom.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.telecom.description")}
            </p>
            <ul className="list-disc ml-6 mb-8">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.telecom.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.telecom.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.telecom.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.telecom.opportunity")}
              </li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.description")}
            </p>
            <ul className="list-disc ml-6 mb-4">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.opportunity")}
              </li>
            </ul>
            <a
              href="/artikler/helseinformasjon-alle-kan-forsta"
              className="underline hover:text-contrast-ink"
            >
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.health.link")}
            </a>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.description")}
            </p>
            <ul className="list-disc ml-6 mb-4">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.opportunity")}
              </li>
            </ul>
            <a
              href="/artikler/offentlig-sektor-tilgjengelige-dokumenter"
              className="underline hover:text-contrast-ink"
            >
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.public.link")}
            </a>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.energy.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.energy.description")}
            </p>
            <ul className="list-disc ml-6 mb-8">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.energy.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.energy.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.energy.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.energy.opportunity")}
              </li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.education.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.education.description")}
            </p>
            <ul className="list-disc ml-6 mb-8">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.education.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.education.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.education.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.education.opportunity")}
              </li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.transport.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.transport.description")}
            </p>
            <ul className="list-disc ml-6 mb-12">
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.transport.riskLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.transport.risk")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.transport.opportunityLabel")}</b>
                {" "}
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.transport.opportunity")}
              </li>
            </ul>

            <h2 className="text-4xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.conclusion.title")}
            </h2>
            <ul className="list-disc ml-6 mb-12">
              <li>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.conclusion.features.1")}</li>
              <li>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.conclusion.features.2")}</li>
              <li>{i18next.t("pages.articles.list.eaaCompetitiveness.sections.conclusion.features.3")}</li>
            </ul>
            <p className="text-lg font-semibold">
              {i18next.t("pages.articles.list.eaaCompetitiveness.sections.cta.content")}
              <a href="/skjema/kontakt-oss" className="text-lg font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.eaaCompetitiveness.sections.cta.link")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EAAKonkurranseevne;


